module.exports = __webpack_public_path__ + "img/pick5.09cfab74.png";